import { toastServerError } from '../global/notifications'

export const SESSION_EXPIRED_PARAM = 'sessionExpired'
export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again.'

// Recovery after the session is torn down mid-page: the page's other requests
// already failed with the dead token, so an SPA navigation would leave their
// reducers holding errors — only a full re-bootstrap recovers them. Persisted
// state must be flushed before the reload, or the cleared auth slice never
// reaches localStorage and the reload resurrects the dead token in a loop.
// The store is imported dynamically because store.js imports the middlewares
// that call this.
export const reloadAsLoggedOut = async () => {
  const { persistor } = await import('../redux/store')
  if (persistor) await persistor.flush()
  window.location.assign(`/?${SESSION_EXPIRED_PARAM}=1`)
}

// Reads the flag reloadAsLoggedOut leaves in the URL so the app can explain
// the logout once it boots. The caller strips the param from the URL.
export const toastIfSessionExpired = (search) => {
  const expired =
    new URLSearchParams(search).get(SESSION_EXPIRED_PARAM) === '1'
  if (expired) toastServerError(SESSION_EXPIRED_MESSAGE)
  return expired
}
